import { render, staticRenderFns } from "./PlotCard.vue?vue&type=template&id=0a8651c7&scoped=true&"
import script from "./PlotCard.vue?vue&type=script&lang=js&"
export * from "./PlotCard.vue?vue&type=script&lang=js&"
import style0 from "./PlotCard.vue?vue&type=style&index=0&id=0a8651c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8651c7",
  null
  
)

export default component.exports